<template>
    <div>
        <label
            :for="name"
            class="font-medium text-sm sm:text-base"
        >
            <slot></slot>
        </label>
        <v-select
            :id="name"
            :name="name"
            class="bg-white text-sm border-2 border-brown"
            :class="[classes]"
            label="description"
            :disabled="disabled || !options.length"
            :loading="loading"
            :options="options"
            :value="getOption(value)"
            @input="$emit('input', $event)"
            @search:focus="onSearchFocus"
            @search:blur="onSearchBlur"
        >
            <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                    No hay resultados para: {{ search }}
                </template>
                <template v-else>{{ waitingText }}</template>
            </template>
            <template #open-indicator="{ attributes }">
                <div
                    v-bind="attributes"
                    class="open-indicator"
                ></div>
            </template>
        </v-select>
    </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    components: {
        "v-select": vSelect,
    },
    props: [
        "name",
        "invalid",
        "value",
        "options",
        "classes",
        "disabled",
        "loading",
        "waitingText",
    ],
    methods: {
        getOption(value) {
            if (!value) {
                return "";
            } else if (value.id) {
                return value;
            } else if (this.options.length) {
                let option = this.options.find((option) => option.id === value);
                this.$emit("input", option);
                return option;
            } else {
                let option = {
                    id: value,
                };
                return option;
            }
        },
        onSearchFocus() {
            this.classes["border-2"] = true;
            this.classes["border-solid"] = true;
            this.classes["border-red"] = false;
            this.classes["border-light-blue"] = true;
        },
        onSearchBlur() {
            if (this.invalid) {
                this.classes["border-light-blue"] = false;
                this.classes["border-red"] = true;
                this.classes["border-2"] = true;
                this.classes["border-solid"] = true;
            } else {
                this.classes["border-light-blue"] = false;
                this.classes["border-2"] = false;
                this.classes["border-solid"] = false;
            }
        },
    },
};
</script>

<style>
</style>